export enum OrderPreviewView {
    Overview = 'overview',
    ExtraInfo = 'extra-info',
    Upload = 'upload',
    Payment = 'payment',
    Mail = 'mail',
}
